module.exports = __webpack_public_path__ + "img/20_18.0183a783.png";